export default __webpack_public_path__ + "static/media/select-icon.ef732be3.svg";